//
// Copyright (c) 2011-2026 by Curalate, Inc.
//

export const CuralateAuthTokenHeader = 'X-Curalate-Auth-Token';
